import { defineMessages } from 'react-intl'

export default defineMessages({
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  confirmDelete: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteInputLabel',
    defaultMessage: 'Enter the name of the app to confirm this action:'
  },
  delete: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteApp',
    defaultMessage: 'Delete App?'
  },
  deleteButton: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteAppButton',
    defaultMessage: 'Delete App'
  },
  subMessage: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteSubMessage',
    defaultMessage: "This is an unrecoverable action, there's no going back! This app will be permanently deleted."
  },
  warning: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteWarning',
    defaultMessage: 'You are about to delete the {appName} app.'
  },
  back: {
    id: 'SpaceCustomAppEditPage.BackToApps',
    defaultMessage: 'Back to Installed Apps'
  },
  deleting: {
    id: 'Deleting',
    defaultMessage: 'Deleting...'
  },
  deleteFailed: {
    id: 'SpaceCustomAppEditPage.DeleteFailed',
    defaultMessage: 'The app failed to delete at this time.'
  },
  deleteSuccess: {
    id: 'SpaceCustomAppEditPage.AppDeleted',
    defaultMessage: 'Done! App deleted.'
  },
  developerGuide: {
    id: 'SpaceCustomAppEditPage.AddAppDescription.AppDeveloperGuide',
    defaultMessage: 'App Developer Guide'
  },
  installApp: {
    id: 'SpaceCustomAppEditPage.CustomAppForm.InstallNewApp',
    defaultMessage: 'Install New App'
  },
  installing: {
    id: 'SpaceCustomAppEditPage.InstallingApp',
    defaultMessage: 'Installing App...'
  },
  saving: {
    id: 'Saving',
    defaultMessage: 'Saving...'
  },
  installSuccess: {
    id: 'SpaceCustomAppEditPage.CustomAppForm.Completion.Success',
    defaultMessage: 'Nice. Your App is created!'
  },
  title: {
    id: 'SpaceCustomAppEditPage.Title',
    defaultMessage: 'Custom App'
  },
  tryAgain: {
    id: 'TryAgain',
    defaultMessage: 'Try Again'
  },
  updateFailed: {
    id: 'SpaceCustomAppEditPage.UpdateFailed',
    defaultMessage: 'The App failed to update at this time.'
  },
  updateSuccess: {
    id: 'SpaceCustomAppEditPage.UpdateSuccess',
    defaultMessage: 'All set! App Settings Successfully Updated'
  }
})
